import styled, { css } from 'styled-components';
import { Box, Button, MenuButton, MenuItem } from '@bechtel/gds';

export const PopperContainerStyled = styled(Box)`
  ${({ theme }) => css`
    border-radius: ${theme.spacings[200]};
    display: flex;
    align-items: baseline;
    position: absolute;
    z-index: 1;
    top: ${theme.spacings[700]};
    right: 0;
  `}
`;

export const ExpiredRodRequestIconStyled = styled.div`
  ${({ theme }) => css`
    border: solid 1px ${theme.colors.white};
    color: ${theme.colors.white};
    width: calc(${theme.spacings[500]} + ${theme.spacings[100]});
    height: calc(${theme.spacings[500]} + ${theme.spacings[100]});
    border-radius: ${theme.spacings[600]};
    background-color: ${theme.colors.bechtel.red};
    font-weight: ${theme.fontWeights[600]};
    padding-left: ${theme.spacings[300]};
    right: -${theme.spacings[400]};
    top: calc(-${theme.spacings[300]} - ${theme.spacings[200]});
  `}
  position: absolute;
  line-height: 1.3;
`;

interface MenuButtonProps {
  isDisabled: boolean;
}
export const MenuButtonStyled = styled(MenuButton)<MenuButtonProps>`
  ${({ theme }) => css`
    padding: ${theme.spacings[400]};
    display: inline-flex;
    border-color: none;
    pointer-events: all;
    height: ${theme.spacings['700']};
    opacity: 1;
    align-items: center;
    box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px, rgb(0 0 0 / 12%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px;
    &:focus {
      box-shadow: none;
    }
  `}
  ${(props: MenuButtonProps) =>
    props.isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.6;
    `}
`;
interface MenuItemStyledProps {
  isActive: boolean;
  isDisabled: boolean;
}
export const MenuItemStyled = styled(MenuItem)<MenuItemStyledProps>`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    padding-left: ${theme.spacings[500]};
    color: ${theme.colors.grey[1000]};
    white-space: nowrap;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.bechtel.blue[100]};
    }
    ${(props: MenuItemStyledProps) =>
      props.isActive &&
      css`
        background-color: ${theme.colors.bechtel.blue[100]};
        &:hover {
          background-color: ${theme.colors.bechtel.blue[100]};
        }
      `}
    ${(props: MenuItemStyledProps) =>
      props.isDisabled &&
      css`
        pointer-events: none;
        opacity: 0.6;
      `}
  `}
`;
export const GrabButtonStyled = styled(Button)`
  ${({ theme }) => css`
    margin-right: ${theme.spacings[300]};
    margin-left: ${theme.spacings[300]};
    width: auto;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 2px 1px -1px rgb(0 0 0 / 12%), 0 1px 1px 0 rgb(0 0 0 / 14%);
  `}
`;
